import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import '../../assets/css/Accordion.css';
import Rotator from './Rotator';
import Video from './Video';
import { checkUrlPath } from './CommonFunctions';

const HeadingUnderline ={
    "text-decoration" :"underline"
}
class Accordion extends React.Component {
    constructor(props) {
        super(props);
        this.IsServiceOutage = false;
        if ((window.location.href.indexOf("serviceoutage") > -1)||(window.location.href.indexOf("service-outage") > -1)) {
            console.log("testing-service")
            this.IsServiceOutage = true;
        }
    }

    accordionContentTabFocus(accordionItem,ariahiddenvalue,tabindexvalue){
        // DOPMO- 156656*
        const iframe = accordionItem.nextElementSibling.querySelectorAll ("iframe");
        for(var i=0; i<iframe.length; i++){
            iframe[i].setAttribute("tabIndex", tabindexvalue);
            iframe[i].setAttribute("aria-hidden", ariahiddenvalue);
        }

        const atagiframe = accordionItem.nextElementSibling.querySelectorAll("iframe div a");
            for(var i=0; i<atagiframe.length; i++){
                atagiframe[i].setAttribute("tabIndex", tabindexvalue);
                atagiframe[i].setAttribute("aria-hidden", ariahiddenvalue);
            }

        const atag = accordionItem.nextElementSibling.querySelectorAll("p a");
        for(var i=0; i<atag.length; i++){
            atag[i].setAttribute("tabIndex", tabindexvalue);
            atag[i].setAttribute("aria-hidden", ariahiddenvalue);
            atag[i].classList.add('anochorUnderlin');
        }
        //DOPMO-157298
        // const tabletag = accordionItem.nextElementSibling.querySelectorAll("table");
        // for(var i=0; i<tabletag.length; i++){
        //     tabletag[i].setAttribute("tabIndex", tabindexvalue);
        //     tabletag[i].setAttribute("aria-hidden", ariahiddenvalue);
        // }
    }

    openCloseAccordionItem(e) {
        e.preventDefault();
        let accordionItem = (e.target.parentElement.classList.contains('m_accordion-summary')) ? (e.target.parentElement) : e.target;
        if(accordionItem.classList.contains('open')) {
            accordionItem.removeAttribute("role");
            accordionItem.classList.remove('open');
            accordionItem.nextElementSibling.classList.remove('show-content');
            accordionItem.nextElementSibling.classList.add('hide-content');
            accordionItem.nextElementSibling.setAttribute("aria-hidden", "true");
            accordionItem.setAttribute("aria-expanded", "false");
            this.accordionContentTabFocus(accordionItem,"true","-1");
          
        } else {
            accordionItem.classList.add('open');
            accordionItem.setAttribute("role", "button");
            accordionItem.nextElementSibling.classList.add('show-content');
            accordionItem.nextElementSibling.classList.remove('hide-content');
            accordionItem.nextElementSibling.setAttribute("aria-hidden", "false");
            accordionItem.setAttribute("aria-expanded", "true");           
          //  DOPMO-133464 
          let nextitem = accordionItem.nextElementSibling;
          if(nextitem.firstElementChild.getAttribute("data-list-content") != null){
              let ULListCount = nextitem.firstElementChild;
              let childlist = ULListCount.children;
              for(var i=0;i<childlist.length;i++){
                  childlist[i].firstElementChild.setAttribute("tabIndex", "0");
              }         
          }
          this.accordionContentTabFocus(accordionItem,"false","0");   
        }
    }


    handleKeyAction(e) {
        if((e.target.classList.contains('accordionTitle') || e.target.classList.contains('m_accordion-summary')) && e.keyCode === 13) {
            this.openCloseAccordionItem(e);
        }
    }

    openCloseAccordionKeys(e){    
        let item = "test" +e.keyCode;
        let accordionItem = (e.target.parentElement.classList.contains('m_accordion-summary')) ? (e.target.parentElement) : e.target;
        if(e.keyCode ===13){
            console.log(item);
            if(accordionItem.classList.contains('open')) {
                accordionItem.removeAttribute("role");
                accordionItem.classList.remove('open');
                accordionItem.nextElementSibling.classList.remove('show-content');
                accordionItem.nextElementSibling.classList.add('hide-content');
                accordionItem.nextElementSibling.setAttribute("aria-hidden", "true");
                accordionItem.setAttribute("aria-expanded", "false");
                this.accordionContentTabFocus(accordionItem,"true","-1");

            } else {            
                accordionItem.setAttribute("role", "button");
                accordionItem.classList.add('open');
                accordionItem.nextElementSibling.classList.add('show-content');
                accordionItem.nextElementSibling.classList.remove('hide-content');
                accordionItem.nextElementSibling.setAttribute("aria-hidden", "false");
                accordionItem.setAttribute("aria-expanded", "true");
                //  DOPMO-133464 
                let nextitem = accordionItem.nextElementSibling;
                if(nextitem.firstElementChild.getAttribute("data-list-content") != null){
                    let ULListCount = nextitem.firstElementChild;
                    let childlist = ULListCount.children;
                    for(var i=0;i<childlist.length;i++){
                        childlist[i].firstElementChild.setAttribute("tabIndex", "0");
                    }  
                } 
                this.accordionContentTabFocus(accordionItem,"false","0");   
            }
        }
    }

    checkLastLink(e){
        if(e.keyCode == 9 && !e.shiftKey){
          
        if(e.target.nextElementSibling.nextElementSibling == null && e.target.getAttribute("aria-expanded") =="false"){
                  
            e.preventDefault() ;
           var btnclose =  document.getElementById("btnClosebutton");
         
          
           setTimeout(() => {           
            try{              
        console.log("testttt")
                
               
                btnclose.focus();
            }catch(e){}
          
        }, 100);
        }
     }
    }
    handleonKeydownActions(e){
        if(e.keyCode == 13){
            this.openCloseAccordionKeys(e);
        }else{
           this.checkLastLink(e); 
        }
    }
    render() {
        
        if(this.props.DataSource !== undefined && this.props.DataSource.length > 0 && (this.props.PopupList === null || this.props.PopupList=== undefined)) {
        return(
            <div className="cmb-container margin-bottom-xlarge accordion-wrapper">
                <div className="row" >
                    <div className="columns tiny-12">
                        {
                          this.IsServiceOutage &&<h2 style={HeadingUnderline}>
                               {ReactHtmlParser(this.props.Header)}
                             </h2>  
                        }
                        {
                            !this.IsServiceOutage &&<div className="h4">
                            {ReactHtmlParser(this.props.Header)}
                          </div> 
                        }                    
                        <ul key="Accordion_wrapper" className="w_list-control">
                        {
                            this.props.DataSource.map((item, index) => {
                                if (item.carousellist !== undefined && item.carousellist !== null && item.carousellist.length >0 && item.carousellist[0].type ==="replacement") {
                                    return <React.Fragment key={"fragment"+index}>
                                    <li aria-expanded={false} key={"item-tile"+index} className="m_accordion-summary" onKeyDown={this.handleKeyAction.bind(this)} data-item={ "item-" + index } role="button" tabIndex="0" onClick={this.openCloseAccordionItem.bind(this)} aria-label={item.accordianHeading}>
                                        <h3 className="accordionTitle"  >{item.accordianHeading }</h3>
                                    </li>
                                    
                                    <li aria-hidden={true} key={"item-dec"+index} className="m_accordion-details" data-item={ "item-" + index }> {
                                        <React.Fragment key={"content"+index}>
                                            <TextContent Data={item.accordionrte}></TextContent>
                                            <Rotator type="replacement" Data={item.carousellist[0].replacement}></Rotator>
                                            <Video Data={item.collist}></Video>
                                        </React.Fragment>
                                    }
                                    </li>
                                    </React.Fragment>
                                } else if (item.carousellist !== undefined && item.carousellist !== null && item.carousellist.length >0 && item.carousellist[0].type ==="battery") {
                                return <React.Fragment key={"fragment"+index}>
                                <li aria-expanded={false} key={"item-tile"+index} className="m_accordion-summary" onKeyDown={this.handleKeyAction.bind(this)} data-item={ "item-" + index } role="button" tabIndex="0" onClick={this.openCloseAccordionItem.bind(this)} aria-label={item.accordianHeading}>
                                    <h3 className="accordionTitle">{item.accordianHeading }</h3>
                                </li>
                                
                                <li aria-hidden={true} key={"item-dec"+index} className="m_accordion-details testing" data-item={ "item-" + index }  tabIndex="-1"> {
                                   <React.Fragment key={"content"+index}>
                                        <TextContent Data={item.accordionrte}></TextContent>
                                        <Rotator type="battery" Data={item.carousellist[0].battery}></Rotator>
                                        <Video Data={item.collist}></Video>
                                    </React.Fragment>
                                }
                                </li>
                                </React.Fragment>
                            } else if(item.accordionrte !=="" && (item.carousellist == undefined || item.carousellist !== null)) {
                                return <React.Fragment key={"fragment"+index}>
                                <li aria-expanded={false} key={"item-tile"+index} className="m_accordion-summary" data-item={ "item-" + index } role="button" tabIndex="0" onClick={this.openCloseAccordionItem.bind(this)} onKeyDown={this.handleKeyAction.bind(this)} aria-label={item.accordianHeading} >
                                    <h3 className="accordionTitle">{item.accordianHeading }</h3>
                                </li>
                                {
                                 this.IsServiceOutage && <li aria-hidden={true} key={"item-dec"+index} className="m_accordion-details hide-content" data-item={ "item-" + index }> {ReactHtmlParser(item.accordionrte) }</li>
                               }
                               {
                                   !this.IsServiceOutage && <li aria-hidden={true} key={"item-dec"+index} className="m_accordion-details " data-item={ "item-" + index }> {ReactHtmlParser(item.accordionrte) }</li>
                               }
                                </React.Fragment>
                            } else if(item.accordionrte ==="" && (item.ctalist !== null && item.ctalist !== undefined) && item.ctalist.length > 0) {
                                return <React.Fragment key={"fragment"+index}>
                                <li aria-expanded={false} key={"item-tile"+index} className="m_accordion-summary" onKeyDown={this.handleKeyAction.bind(this)} data-item={ "item-" + index } role="button" tabIndex="0" onClick={this.openCloseAccordionItem.bind(this)} aria-label={item.accordianHeading}>
                                    <h3 className="accordionTitle">{item.accordianHeading }</h3>
                                </li>
                                
                                <li aria-hidden={true} key={"item-dec"+index} className="m_accordion-details cta" data-item={ "item-" + index } tabIndex="-1"> 
                                    <a className="m_button1-next" href={checkUrlPath(item.ctalist[0].linkTo)} target="_self" data-track={item.ctalist[0].label1}>{item.ctalist[0].label1}</a>
                                </li>
                                </React.Fragment>
                            }
                            })
                        }
                        </ul>
                    </div>
                </div>
            </div>
        )
    } else if(this.props.PopupList !== null && this.props.PopupList !== undefined && this.props.PopupList.length > 0) {
        return(
                this.props.DataSource.map((item, index) => {
                    return <React.Fragment key={"fragment"+index}>
                    <li id="liaccordionheading" aria-expanded={false} key={"item-tile"+index} className="m_accordion-summary popuplist" data-item={ "item-" + index }  tabIndex="0" onClick={this.openCloseAccordionItem.bind(this)} aria-label={item.accordianHeading} onKeyDown={this.handleonKeydownActions.bind(this)}>
                        {item.accordianHeading}
                    </li>
                    
                    <li aria-hidden={true} key={"item-dec"+index} className="m_accordion-details popupcontent" data-item={ "item-" + index }  >
                      <Lists Data={this.props.PopupList}/>
                    </li>
                    </React.Fragment>
                }, this)
        )
    } else {
        return null
    }
    }
}

export default Accordion

function TextContent(TextContent) {
    if(TextContent.Data !== null && TextContent.Data !== undefined) {
        return (
            <React.Fragment>
                {
                    ReactHtmlParser(TextContent.Data)
                }
            </React.Fragment>
        )
    } else {
        return null
    }
}

function Lists(ListData) {
    return(
        <ul className="w_list-control m_article-list" key="Dialog_Content" data-list-content="contentlist">
        {
            ListData.Data.map((listItem, listIndex)=> {
                return <li id="liaccordionList" data-item-index={listIndex} className="links" key={"link"+listIndex}>
                    <a data-track={listItem.linktex} className="m_next" href={checkUrlPath(listItem.linkurl)} tabIndex="-1" >{listItem.linktext}</a>
                </li>
            })
        }
        </ul>
    )
}



// WEBPACK FOOTER //
// ./src/components/modules/Accordion.js